import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type SegmentoPlu = {
  id: string;
  valor: string;
  titulo: string;
  detalle: string;
};

const SEGMENTOS: SegmentoPlu[] = [
  {
    id: 'id1',
    valor: '2',
    titulo: 'Identificador',
    detalle: 'Primer dígito del código.',
  },
  {
    id: 'plu',
    valor: '0001',
    titulo: 'Código PLU',
    detalle: 'Código del artículo, en 4 dígitos. No es el código de barras.',
  },
  {
    id: 'relleno',
    valor: '0',
    titulo: 'Relleno',
    detalle: 'Dígito de relleno.',
  },
  {
    id: 'valor',
    valor: '04349',
    titulo: 'Precio o peso',
    detalle: 'Precio final si el PLU es por precio, o peso si el PLU es por cantidad.',
  },
  {
    id: 'id2',
    valor: '0',
    titulo: 'Identificador',
    detalle: 'Último dígito del código.',
  },
];

type PluAyudaDialogProps = {
  open: boolean;
  onClose: () => void;
};

const PluAyudaDialog: React.FC<PluAyudaDialogProps> = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle sx={{ pr: 6, position: 'relative' }}>
      Cómo funciona el PLU
      <IconButton
        aria-label="Cerrar ayuda del PLU"
        onClick={onClose}
        sx={{ position: 'absolute', right: 8, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers>
      <Stack spacing={2}>
        <Typography variant="body2" color="text.secondary">
          El código que imprime la balanza tiene siempre 12 dígitos y este formato.
        </Typography>
        <Typography
          component="div"
          sx={{
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
            fontWeight: 700,
            fontSize: '1.15rem',
            letterSpacing: '0.06em',
            color: '#1976d2',
          }}
        >
          2-0001-0-04349-0
        </Typography>
        <Stack spacing={1.25}>
          {SEGMENTOS.map((segmento) => (
            <Stack key={segmento.id} direction="row" spacing={1.5} alignItems="flex-start">
              <Typography
                sx={{
                  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
                  fontWeight: 700,
                  minWidth: 72,
                  color: '#1976d2',
                }}
              >
                {segmento.valor}
              </Typography>
              <Box>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {segmento.titulo}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {segmento.detalle}
                </Typography>
              </Box>
            </Stack>
          ))}
        </Stack>
        <Typography variant="body2">
          El campo PLU de la ficha define cómo se lee el bloque de 5 dígitos al facturar.
        </Typography>
        <Typography variant="body2">
          <strong>Precio.</strong> Esos dígitos son el precio final, como número entero: 04349 es 4349.
          La cantidad se calcula dividiendo ese importe por el precio unitario del artículo.
        </Typography>
        <Typography variant="body2">
          <strong>Cantidad.</strong> Esos dígitos son el peso, con 3 decimales: 04349 es 4,349.
        </Typography>
        <Typography variant="body2">
          <strong>No usa.</strong> El artículo no se vende con código de balanza.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Los 4 dígitos del código PLU tienen que coincidir con el código del artículo. Si el lector
          entrega 13 dígitos, se descarta el primero y se usan los 12 restantes.
        </Typography>
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} variant="contained" sx={{ textTransform: 'none' }}>
        Entendido
      </Button>
    </DialogActions>
  </Dialog>
);

export default PluAyudaDialog;
